"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemRightEnum = exports.RightEnum = void 0;
/**
 * Rights which are granted by a role.
 *
 * All the rights allow a user to do actions in the company they have that role.
 *
 * Naming convention: {DOMAIN}__{SCOPE}__{ACTION}
 * 1. If {DOMAIN}, {ACTION} or {SCOPE} are 2 words or more use ONE underscore e.g. DOMAIN=COMPANY_SETTINGS, ACTION=CREATE_UNAPPORVED
 * 2. If an {ACTION} does not grant any rights to modify/write/delete or otherwise changes resources the {ACTION} should always be READ
 */
var RightEnum;
(function (RightEnum) {
    // Inbox Invoice rights
    RightEnum["INBOX_INVOICE__ALL__READ"] = "INBOX_INVOICE__ALL__READ";
    RightEnum["INBOX_INVOICE__ALL__ASSIGN"] = "INBOX_INVOICE__ALL__ASSIGN";
    /**
     * Create and delete inbox invoices
     */
    RightEnum["INBOX_INVOICE__ALL__WRITE"] = "INBOX_INVOICE__ALL__WRITE";
    // Company rights
    RightEnum["COMPANY_FEATURE_SETTINGS__ALL__READ"] = "COMPANY_FEATURE_SETTINGS__ALL__READ";
    RightEnum["COMPANY_FEATURE_SETTINGS__ALL__WRITE"] = "COMPANY_FEATURE_SETTINGS__ALL__WRITE";
    RightEnum["COMPANY_ACCOUNTING_SETTINGS__ALL__READ"] = "COMPANY_ACCOUNTING_SETTINGS__ALL__READ";
    RightEnum["COMPANY_ACCOUNTING_SETTINGS__ALL__WRITE"] = "COMPANY_ACCOUNTING_SETTINGS__ALL__WRITE";
    // User rights
    RightEnum["EMPLOYEE__ALL__READ"] = "EMPLOYEE__ALL__READ";
    RightEnum["EMPLOYEE__ALL__UPDATE"] = "EMPLOYEE__ALL__UPDATE";
    RightEnum["EMPLOYEE__TEAM__READ"] = "EMPLOYEE__TEAM__READ";
    RightEnum["EMPLOYEE__TEAM__UPDATE"] = "EMPLOYEE__TEAM__UPDATE";
    RightEnum["EMPLOYEE_APPROVAL_DATA__ALL__UPDATE"] = "EMPLOYEE_APPROVAL_DATA__ALL__UPDATE";
    RightEnum["EMPLOYEE_APPROVAL_DATA__TEAM__UPDATE"] = "EMPLOYEE_APPROVAL_DATA__TEAM__UPDATE";
    // Cost Center 1 rights
    RightEnum["CC1__ALL__READ"] = "CC1__ALL__READ";
    RightEnum["CC1__ALL__MANAGE"] = "CC1__ALL__MANAGE";
    /**
     * User can be assigned as CC1 owner
     */
    RightEnum["CC1__ALL__OWNER"] = "CC1__ALL__OWNER";
    // Vendor rights
    RightEnum["VENDOR__ALL__CREATE"] = "VENDOR__ALL__CREATE";
    RightEnum["VENDOR__ALL__CREATE_UNAPPROVED"] = "VENDOR__ALL__CREATE_UNAPPROVED";
    RightEnum["VENDOR__ALL__READ"] = "VENDOR__ALL__READ";
    RightEnum["VENDOR__ALL__UPDATE"] = "VENDOR__ALL__UPDATE";
    RightEnum["VENDOR_CONTRACT__ALL__READ"] = "VENDOR_CONTRACT__ALL__READ";
    RightEnum["VENDOR_CONTRACT__ALL__UPDATE"] = "VENDOR_CONTRACT__ALL__UPDATE";
    RightEnum["VENDOR_PAYMENT_DATA__ALL__READ"] = "VENDOR_PATYMENT_DATA__ALL__READ";
    RightEnum["VENDOR_PAYMENT_DATA__ALL__CREATE"] = "VENDOR_PAYMENT_DATA__ALL__CREATE";
    // Workflow rights
    RightEnum["WORKFLOW__ALL__CREATE"] = "WORKFLOW__ALL__CREATE";
    RightEnum["WORKFLOW__ALL__READ"] = "WORKFLOW__ALL__READ";
    RightEnum["WORKFLOW__ALL__UPDATE"] = "WORKFLOW__ALL__UPDATE";
    RightEnum["WORKFLOW__ALL__DELETE"] = "WORKFLOW__ALL__DELETE";
    // Transaction rights
    RightEnum["TRANSACTION__ALL__READ"] = "TRANSACTION__ALL__READ";
    RightEnum["TRANSACTION__ALL__UPDATE"] = "TRANSACTION__ALL__UPDATE";
    // Liquidity rights
    RightEnum["LIQUIDITY__ALL__READ"] = "LIQUIDITY__ALL__READ";
    RightEnum["LIQUIDITY__ALL__UPDATE"] = "LIQUIDITY__ALL__UPDATE";
    // Reporting rights
    RightEnum["REPORTING__ALL__READ"] = "REPORTING__ALL__READ";
    // Banking rights
    RightEnum["BANK_ACCOUNT__ALL__READ"] = "BANK_ACCOUNT__ALL__READ";
    RightEnum["BANK_ACCOUNT__ALL__CREATE"] = "BANK_ACCOUNT__ALL__CREATE";
    // Card rights
    RightEnum["CARD__ALL__READ"] = "CARD__ALL__READ";
    RightEnum["CARD__TEAM__READ"] = "CARD__TEAM__READ";
    /**
     * Create, update, delete cards
     */
    RightEnum["CARD__ALL__WRITE"] = "CARD__ALL__WRITE";
    /**
     * Create, update, delete cards of team members
     */
    RightEnum["CARD__TEAM__WRITE"] = "CARD__TEAM__WRITE";
    RightEnum["CARD_WALLET__ALL__READ"] = "CARD_WALLET__ALL__READ";
    /**
     * Add funding (etc.)
     */
    RightEnum["CARD_WALLET__ALL__MANAGE"] = "CARD_WALLET__ALL__MANAGE";
    // Expense rights
    RightEnum["EXPENSE__ALL__READ"] = "EXPENSE__ALL__READ";
    RightEnum["EXPENSE__TEAM__READ"] = "EXPENSE__TEAM__READ";
    RightEnum["EXPENSE__ALL__CREATE"] = "EXPENSE__ALL__CREATE";
    RightEnum["EXPENSE__ALL__CREATE_ON_BEHALF"] = "EXPENSE__ALL__CREATE_ON_BEHALF";
    RightEnum["EXPENSE__ALL__PAY_BY_BANK"] = "EXPENSE__ALL__PAY_BY_BANK";
    RightEnum["EXPENSE__ALL__REVIEW"] = "EXPENSE__ALL__REVIEW";
    RightEnum["EXPENSE__ALL__EXPORT"] = "EXPENSE__ALL__EXPORT";
    RightEnum["EXPENSE__ALL__APPROVE_REJECT_DASHBOARD"] = "EXPENSE__ALL__APPROVE_REJECT_DASHBOARD";
    RightEnum["EXPENSE__ALL__APPROVE"] = "EXPENSE__ALL__APPROVE";
    RightEnum["EXPENSE__ALL__RESET_STATUS"] = "EXPENSE__ALL__RESET_STATUS";
    RightEnum["EXPENSE__ALL__ARCHIVE"] = "EXPENSE__ALL__ARCHIVE";
    RightEnum["EXPENSE__ALL__DELETE"] = "EXPENSE__ALL__DELETE";
    RightEnum["EXPENSE__TEAM__APPROVE"] = "EXPENSE__TEAM__APPROVE";
    RightEnum["EXPENSE__TEAM__RESET_STATUS"] = "EXPENSE__TEAM__RESET_STATUS";
    RightEnum["EXPENSE__TEAM__ARCHIVE"] = "EXPENSE__TEAM__ARCHIVE";
    RightEnum["EXPENSE__TEAM__DELETE"] = "EXPENSE__TEAM__DELETE";
    RightEnum["EXPENSE__ALL__ADJUST_WORKFLOW"] = "EXPENSE__ALL__ADJUST_WORKFLOW";
    RightEnum["EXPENSE__ALL__ACCESS_TABLE_EXPORT_READ"] = "EXPENSE__ALL__ACCESS_TABLE_EXPORT_READ";
    RightEnum["EXPENSE__ALL__ACCESS_TABLE_PAY_READ"] = "EXPENSE__ALL__ACCESS_TABLE_PAY_READ";
    RightEnum["EXPENSE__ALL__ACCESS_TABLE_IN_REVIEW_READ"] = "EXPENSE__ALL__ACCESS_TABLE_IN_REVIEW_READ";
    RightEnum["EXPENSE__BASIC__APPROVE"] = "EXPENSE__BASIC__APPROVE";
    // Expense_subscription rights
    RightEnum["SUBSCRIPTION__ALL__READ"] = "SUBSCRIPTION__ALL__READ";
    RightEnum["SUBSCRIPTION__ALL__WRITE"] = "SUBSCRIPTION__ALL__WRITE";
    RightEnum["SUBSCRIPTION__TEAM__READ"] = "SUBSCRIPTION__TEAM__READ";
    RightEnum["SUBSCRIPTION__TEAM__WRITE"] = "SUBSCRIPTION__TEAM__WRITE";
    RightEnum["COMPANY_CHANGE_HISTORY__ALL__READ"] = "COMPANY_CHANGE_HISTORY__ALL__READ";
    // Purchase Order rights
    RightEnum["PURCHASE_ORDER__ALL__READ"] = "PURCHASE_ORDER__ALL__READ";
    RightEnum["PURCHASE_ORDER__ALL__CREATE"] = "PURCHASE_ORDER__ALL__CREATE";
    RightEnum["PURCHASE_ORDER__ALL__UPDATE"] = "PURCHASE_ORDER__ALL__UPDATE";
    RightEnum["PURCHASE_ORDER__ALL__DELETE"] = "PURCHASE_ORDER__ALL__DELETE";
    RightEnum["PURCHASE_ORDER__ALL__APPROVE"] = "PURCHASE_ORDER__ALL__APPROVE";
    RightEnum["PURCHASE_ORDER__ALL__APPROVE_REJECT_DASHBOARD"] = "PURCHASE_ORDER__ALL__APPROVE_REJECT_DASHBOARD";
    RightEnum["PURCHASE_ORDER__PROCUREMENT__READ"] = "PURCHASE_ORDER__PROCUREMENT__READ";
    RightEnum["PURCHASE_ORDER__PROCUREMENT__WRITE"] = "PURCHASE_ORDER__PROCUREMENT__WRITE";
    RightEnum["PURCHASE_ORDER__PROCUREMENT__APPROVE"] = "PURCHASE_ORDER__PROCUREMENT__APPROVE";
    // Delivery Note rights
    RightEnum["DELIVERY_NOTE__ALL__READ"] = "DELIVERY_NOTE__ALL__READ";
    RightEnum["DELIVERY_NOTE__ALL__UPDATE"] = "DELIVERY_NOTE__ALL__UPDATE";
    /** NOTES
     * make sure to check standardEditRightsArray in role.model.ts when adding a new write right
     * might need to update the test expect in role.model.test.ts when adding a new right
     */
})(RightEnum || (exports.RightEnum = RightEnum = {}));
/**
 * System rights are granted to users how are considered SYSTEM ADMINS.
 */
var SystemRightEnum;
(function (SystemRightEnum) {
    // Role rights
    SystemRightEnum["SYS__ROLE__ALL__READ"] = "SYS__ROLE__ALL__READ";
    SystemRightEnum["SYS__ROLE__ALL__CREATE"] = "SYS__ROLE__ALL__CREATE";
    SystemRightEnum["SYS__ROLE__ALL__UPDATE"] = "SYS__ROLE__ALL__UPDATE";
    SystemRightEnum["SYS__ROLE__ALL__DELETE"] = "SYS__ROLE__ALL__DELETE";
    // User rights
    SystemRightEnum["SYS__USER__ALL__READ"] = "SYS__USER__ALL__READ";
    SystemRightEnum["SYS__USER__ALL__CREATE"] = "SYS__USER__ALL__CREATE";
    SystemRightEnum["SYS__USER__ALL__UPDATE"] = "SYS__USER__ALL__UPDATE";
    SystemRightEnum["SYS__USER__ALL__DELETE"] = "SYS__USER__ALL__DELETE";
    // Company rights
    SystemRightEnum["SYS__COMPANY__ALL__READ"] = "SYS__COMPANY__ALL__READ";
    SystemRightEnum["SYS__COMPANY__ALL__CREATE"] = "SYS__COMPANY__ALL__CREATE";
    SystemRightEnum["SYS__COMPANY__ALL__UPDATE"] = "SYS__COMPANY__ALL__UPDATE";
    SystemRightEnum["SYS__COMPANY__ALL__DELETE"] = "SYS__COMPANY__ALL__DELETE";
    /**
     * Right for managing payment settings (e.g. update payment method, change subscription, etc.)
     */
    SystemRightEnum["SYS__PAYMENT_SETTINGS__ALL__MANAGE"] = "SYS__PAYMENT_SETTINGS__ALL__MANAGE";
    /**
     * Right for managing IDP related settings (e.g. setup SSO, etc.)
     */
    SystemRightEnum["SYS__IDP__ALL__READ"] = "SYS__IDP__ALL__READ";
    SystemRightEnum["SYS__IDP__ALL__CREATE"] = "SYS__IDP__ALL__CREATE";
    SystemRightEnum["SYS__IDP__ALL__UPDATE"] = "SYS__IDP__ALL__UPDATE";
    SystemRightEnum["SYS__IDP__ALL__DELETE"] = "SYS__IDP__ALL__DELETE";
    /**
     * Right for managing tenant integration related settings (e.g. personio)
     */
    SystemRightEnum["SYS__INTEGRATION__ALL__READ"] = "SYS__INTEGRATION__ALL__READ";
    SystemRightEnum["SYS__INTEGRATION__ALL__CREATE"] = "SYS__INTEGRATION__ALL__CREATE";
    SystemRightEnum["SYS__INTEGRATION__ALL__UPDATE"] = "SYS__INTEGRATION__ALL__UPDATE";
    SystemRightEnum["SYS__INTEGRATION__ALL__DELETE"] = "SYS__INTEGRATION__ALL__DELETE";
    /**
     * Right to upload spreadsheet data to the system.
     */
    SystemRightEnum["SYS__DATA_IMPORT__ALL__READ"] = "SYS__DATA_IMPORT__ALL__READ";
    SystemRightEnum["SYS__DATA_IMPORT__ALL__CREATE"] = "SYS__DATA_IMPORT__ALL__CREATE";
})(SystemRightEnum || (exports.SystemRightEnum = SystemRightEnum = {}));
